import type { ReactNode } from 'react'

interface DocumentSectionProps {
  title: string
  subtitle?: string
  children: ReactNode
  className?: string
}

export default function DocumentSection({ title, subtitle, children, className = '' }: DocumentSectionProps) {
  return (
    <section className={`rounded border border-slate-300 ${className}`.trim()}>
      <div className="border-b border-slate-300 bg-slate-50 px-3 py-2">
        <h2 className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-700">{title}</h2>
        {subtitle && <p className="mt-1 text-xs text-slate-500">{subtitle}</p>}
      </div>
      <div className="px-3 py-3 sm:px-4">{children}</div>
    </section>
  )
}
